﻿import { Directive } from "@app/components/directive";
import { Dirs } from "@app/helpers/dirs";
import { NgComponent } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { KbService } from "@app/services/kb.service";

@NgComponent({
    token: Token.KbEllipsis,
    dependencies: [
        Token.KbService
    ]
})
export class KbEllipsis extends Directive {
    constructor(
        kbService: KbService
    ) {
        super();

        this.restrict = "E";
        this.template = Dirs.component("kb-ellipsis");
        this.scope = false;
        this.replace = true;

        // this.link = (scope, element, atts) => {
        // }
    }
}
